export function processContentWithImages(inputString) {
    const images = {};
    let counter = 1;

    // Replace all img tags with placeholders
    const processedString = inputString.replace(
        /<img([^>]*)src="([^">]+)"([^>]*)>/g,
        (match, beforeSrc, src, afterSrc) => {
            const placeholder = `{img${counter}}`;
            images[`img${counter}`] = src;
            counter++;
            return `<img${beforeSrc}src="${placeholder}"${afterSrc}>`;
        }
    );

    return {
        comment: processedString,
        images: images
    };
}

export function restoreContentWithImages(processedString, images) {
    if (!images || !processedString) {
        return processedString;
    }

    return processedString.replace(
        /src="\{?([^}"]+)\}?"/g,
        (match, placeholder) => {
            const src = images[placeholder];
            return src ? `src="${src}"` : match;
        }
    );
}